import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'output'];

  submit(event) {
    event.preventDefault();

    const value = this.inputTarget.value;
    const id = value.match(/[-\w]{25,}/);

    if (id) {
      const widget = document.getElementById('widget').checked;
      const widgetQuery = widget ? 'true' : 'false';
      const headers = document.getElementById('headers').checked;
      const headersQuery = headers ? 'true' : 'false';

      const output = `<iframe src="https://docs.google.com/spreadsheets/d/${id[0]}/pubhtml?widget=${widgetQuery}&amp;headers=${headersQuery}"></iframe>`;
      this.lastOutput = output;
      navigator.clipboard.writeText(output);

      document.getElementById("copiedToClipboardDiv").classList.remove('hidden')

      // The output is embed markup, not a URL — render it as plain text so it
      // stays selectable and clicking the box re-copies instead of navigating.
      this.outputTarget.textContent = `Copied to clipboard: ${ output }`;
    }
  }

  // Click the result box to copy it again.
  copy() {
    if (!this.lastOutput) return;

    navigator.clipboard.writeText(this.lastOutput);
    this.flashCopied();
  }

  flashCopied() {
    const previous = this.outputTarget.textContent;
    this.outputTarget.textContent = 'Copied to clipboard!';

    window.clearTimeout(this.flashTimeoutId);
    this.flashTimeoutId = window.setTimeout(() => {
      this.outputTarget.textContent = previous;
    }, 1200);
  }
}